import React, { Component } from 'react'
import { connect } from 'react-redux'

class SwappableDiv extends Component {
    constructor(props) {
        super(props)
        this.state = {
            side: 'left'
        }
    }

    render() {
        let sideClass = this.props.side ? 'swappableDivLeft' : 'swappableDivRight'

        return (
            <div className={sideClass}> 
                <blockquote>
                    This will eventually contain information about the page.
                </blockquote>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        side: state.settings.swappablediv,
    }
}

export default connect(mapStateToProps)(SwappableDiv)



// WEBPACK FOOTER //
// ./src/components/SwappableDiv.js